import React from 'react';

const bg = `${process.env.PUBLIC_URL}/photos/sod.jpg`;

const Hero = () => {
    return (
        <section
            id="top"
            className="hero"
            style={{
                backgroundImage:
                    `linear-gradient(rgba(16, 18, 40, 0.62), rgba(16, 18, 40, 0.74)), url(${bg})`,
            }}
        >
            <div className="hero-inner">
                <p className="hero-eyebrow">Региональная общественная организация инвалидов</p>
                <h2 className="hero-sub">Центр семьи и молодёжи</h2>
                <h1 className="hero-title">«Содействие»</h1>
                <p className="hero-tagline">
                    Поддержка семьи и детства · развитие молодёжи · волонтёрство с 2004 года
                </p>
            </div>
            <a href="#director" className="hero-scroll" aria-label="Листать вниз"/>
        </section>
    );
};

export default Hero;
